module.exports = __webpack_public_path__ + "static/media/non_existent.3a500bd1.jpg";